import ApiService from "../../services/ApiService";
import { ListPickupV2RepositoryInterface } from "@/data/persistences/repositories/contracts/ListPickupV2RepositoryInterface";
import { ListPickupV2Mapper } from "@/data/persistences/mappers/ListPickupV2Mapper";
import { ListPickupV2Endpoint } from "../../endpoints/ListPickupV2Endpoint";
import {
  ListPickupParams,
  ListSttRequestPickupRequest
} from "@/data/payload/api/ListPickupV2Request";
import { ShipmentBookingMapper } from "@/data/persistences/mappers/ShipmentBookingMapper";
import { PickupCorporateSummaryRequest } from "@/data/payload/api/ListPickupV2Request";
import {
  PickupCorporateSummary,
  RequestListPickupDetail
} from "@/domain/entities/ListPickupV2";
import { ListPickupDetail } from "@/domain/entities/ListPickupDetailV2";

export class ListPickupV2ApiRepository
  implements ListPickupV2RepositoryInterface {
  constructor(
    private service: ApiService,
    private mapper: ListPickupV2Mapper,
    private shipmentBookingMapper: ShipmentBookingMapper,
    private endpoints: ListPickupV2Endpoint
  ) {}

  async getListSttRequestPickup(params: ListSttRequestPickupRequest) {
    const res = await this.service.invoke(
      "get",
      this.endpoints.getListSttRequestPickup(params),
      {}
    );
    return this.shipmentBookingMapper.convertShipmentBookingFromApi(res);
  }

  async getPickupCorporateSummary(
    params: PickupCorporateSummaryRequest
  ): Promise<PickupCorporateSummary> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getPickupCorporateSummary(params),
      {}
    );

    return this.mapper.convertPickupCorporateSummaryDataFromApi(resp);
  }

  async getListPickupDetail(
    id: string,
    params?: RequestListPickupDetail
  ): Promise<ListPickupDetail> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getListPickupDetail(id, params),
      {}
    );
    return this.mapper.convertDetailDataFromApi(resp);
  }

  async getListPickup(params: ListPickupParams) {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getListPickup(params),
      {}
    );
    return this.mapper.convertListDataFromApi(resp);
  }
}
